import React from 'react';

export default function({children, threeFourths, twoThirdsDesktop, center}){
    
    return <div className={`${threeFourths ? `w-3/4` : ``} ${twoThirdsDesktop ? `md:w-2/3` : ``} ${center ? `text-center` : ``}  mb-5 text-md md:text-lg leading-8 md:leading-8`}>{children}</div>

}